import { AHText, Box, useLayoutContext, useTheme, AHIcon } from "arkh";
import React, { useCallback } from "react";
import { Pressable } from "react-native";
import { useDeviceOrientation } from "../../common/Utils/useDeviceOrientation";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import Color from "color";
import { useNavigation } from "@react-navigation/native";

import { FormattedMessage } from "react-intl";
import { UserLoggedInNavigatorNavigationProp } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export function PLUScreenOnboarding() {
  const { landscape } = useDeviceOrientation();
  const intl_tokens = useIntlTokens();
  const layout = useLayoutContext();
  const theme = useTheme();
  const navigation =
    useNavigation<UserLoggedInNavigatorNavigationProp<"TeamPLU">>();
  const onGetStarted = useCallback(() => {
    navigation.setParams({ isEditing: true });
    navigation.navigateDeprecated("PLUCategoryCreate", {});
  }, [navigation]);
  return (
    <Box
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
      }}
      space="large"
      color="background"
    >
      <Box
        color="surface"
        cornerRadius="medium"
        space="large"
        style={{
          width: "100%",
          maxWidth: 700,
          alignItems: landscape ? "flex-start" : "center",
        }}
      >
        <AHText type="title" spaceBottom="large">
          {intl_tokens.PLU}!
        </AHText>
        <Pressable
          style={(p) => ({
            padding: layout.space.medium,
            backgroundColor: Color(theme.primary)
              .alpha(p.pressed ? 0.4 : 1)
              .toString(),
            borderRadius: layout.radius.medium,
            flexDirection: "row",
            alignItems: "center",
          })}
          onPress={onGetStarted}
        >
          <AHText type="title-small" color="surface" spaceRight="large">
            <FormattedMessage
              defaultMessage="Get started with PLU"
              description="PLUScreenOnboarding CTA"
            />
          </AHText>
          <AHIcon type="arrow-right-circle" customColor={theme.surface} forceSize={layout.icon.medium} />
        </Pressable>
      </Box>
    </Box>
  );
}
